import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import pool, { PoolState } from './pools/pool.store';

export interface NxtplanState {
   pool?: PoolState;
}

const NxtplanStore: Module<NxtplanState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {},
   modules: {
      pool,
   },
};

export default NxtplanStore;
